import React from 'react';

import Upload from './Upload';
import List from './List';

import { Container, Content } from './styles';

import { RequestFileProvider } from '~/context/requestfiles';

interface IUploadRequestFilesProps {
  type: string;
  project_request_temp_id: string;
  project_type: string;
  sequence: number;
  user_id: string;
}

const UploadRequestFiles: React.FC<IUploadRequestFilesProps> = ({
  type,
  project_request_temp_id,
  project_type,
  sequence,
  user_id,
}) => {
  return (
    <RequestFileProvider>
      <Container>
        <Content>
          <Upload
            type={type}
            project_request_temp_id={project_request_temp_id}
            project_type={project_type}
            sequence={sequence}
            user_id={user_id}
          />
          <List />
        </Content>
      </Container>
    </RequestFileProvider>
  );
};

export default UploadRequestFiles;
